export enum ENotificationType {
  PublishMasterData = 'PublishMasterData',
}

export enum ENotificationSource {
  PDM = 'PDM',
}

export enum ENotificationExecution {
  ProductDataSyncInFlight = 'ProductDataSyncInFlight',
}

export enum EMessageType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Default = 'default',
}
